import React from "react";
import { ReactComponent as FacebookIcon } from "../../../../assets/svg/facebook-icon.svg";
import { ReactComponent as GMBIcon } from "../../../../assets/svg/GMB.svg";
import { ReactComponent as LinkedInIcon } from "../../../../assets/svg/linkedin.svg";
import { ReactComponent as PlayStoreIcon } from "../../../../assets/svg/play-store.svg";
import { ReactComponent as TwitterIcon } from "../../../../assets/svg/twitter-logo.svg";
import { ReactComponent as XIcon } from "../../../../assets/svg/x-logo.svg";
import { ReactComponent as YoutubeIcon } from "../../../../assets/svg/youtube-icon.svg";
import { ReactComponent as TelegramIcon } from "../../../../assets/svg/telegram-icon.svg";
// import InstagramIcon from "../../../../assets/instagram.png";
import AppStoreIcon from "../../../../assets/appstore.png";
// import { ReactComponent as AppStoreIcon } from "../../../../assets/svg/app-store.svg";
import InstagramIcon from "../../../../assets/svg/instagram.svg";
import { ReactComponent as InstaIcon } from "../../../../assets/svg/instagram.svg";

const PlatformIcon = (props) => {
    const { platform } = props;
    return (
        <>
            {platform === "facebook" ? (
                <FacebookIcon />
            ) : platform === "instagram" ? (
                props.svg ? (
                    <InstaIcon />
                ) : (
                    <img src={InstagramIcon} className="platform-image img instagramImg instagram__icon" />
                )
            ) : platform === "gmb" ? (
                <GMBIcon />
            ) : platform === "google play store" || platform === "playstore" ? (
                <PlayStoreIcon />
            ) : platform === "linkedin" ? (
                <LinkedInIcon />
            ) : platform === "telegram" ? (
                <TelegramIcon />
            ) : platform === "appstore" ? (
                <img src={AppStoreIcon} className="platform-image img instagramImg" />
            ) : platform === "youtube" ? (
                <YoutubeIcon />
            ) : (
                // : platform === "twitter" ? (
                //     <TwitterIcon />
                // )
                <XIcon />
            )}
        </>
    );
};

export default PlatformIcon;
